<template>
<v-app>
  <contact-form
    :name="name"
    :required-fields="requiredFields"
    buttonText="Anfrage senden">
      <tippgeber-fields :exclude="exclude"></tippgeber-fields>
  </contact-form>
</v-app>
</template>

<script>
import ContactForm from "./ContactForm";
import TippgeberFields from "./TippgeberFields";

export default {
  name: "TippgeberFormApp",

  components: {
    ContactForm,
    TippgeberFields
  },

  data() {
    return {
      name: "tippgeber"
    }
  },

  computed: {
    requiredFields() {
      return this.$yeti.formRequiredFields(this.name);
    },

    authenticationToken() {
      if (this.$store && this.$store.state) {
        return this.$store.state.auth.authenticationToken;
      }

      return null;
    },

    loggedIn() {
      if (this.$store && this.$store.state) {
        return this.$store.state.user.loggedIn;
      }

      return false;
    },

    exclude() {
      let ignoreFields = [];
      if (this.loggedIn) {
        ignoreFields = ["email"];
      }

      let el = [];
      if (this.$root.exclude) {
        el = this.root.exclude;
      }

      return ignoreFields.concat(el);
    }
  }
};
</script>
